import React from 'react'
import { observer } from 'mobx-react'
import { GeoJSON, LayerGroup } from 'react-leaflet'
import IconMarker from './IconMarker'

// Renders a buffer around a point while its being edited
const PointBufferLayer = ({ pointBuffer }) => (
  <LayerGroup>
    {
      pointBuffer.position.latLng !== null
        ? (
          <IconMarker
            icon='draw-handle'
            position={pointBuffer.position.latLng}
            onDragEnd={(latLng) => {
              pointBuffer.position.latLng = latLng
            }}
            className='draw-handle focused'
            draggable
          />
          )
        : null
    }
    {
      pointBuffer.region
        ? (
          <GeoJSON
            color={pointBuffer.getColor}
            key={`${JSON.stringify(pointBuffer.region)}-${pointBuffer.getColor}`}
            data={pointBuffer.region}
            className='region-buffer region-buffer-user-drawn'
            fillOpacity={`${pointBuffer.transparency}%`}
          />
          )
        : null
    }
  </LayerGroup>
)

export default observer(PointBufferLayer)
